import { ClipboardListIcon } from "lucide-react";
import NoPreviewCard from "../card/no-preview-card";

// Interface for the patient questionnaire data
export interface PatientQuestionnaire {
  status: string
  message: string
  questionnaire_responses: {
    [question: string]: string
  }
  initiated_date: string
  supplementary_questionnaire: {
    question_answer: {
      [question: string]: string
    }
  }
}

interface PatientQuestionnaireCardProps {
  data: PatientQuestionnaire
}

export default function PatientQuestionnaireCard({ data }: PatientQuestionnaireCardProps) {
  // Check if there is valid questionnaire data
  if (!data?.questionnaire_responses || Object.keys(data.questionnaire_responses).length === 0) {
    return (
      <NoPreviewCard
        Icon={ClipboardListIcon}
        title="No questionnaire"
        description="This patient has not completed the initial questionnaire yet."
        cardTitle="Initial Questionnaire"
      />
    );
  }

  const { questionnaire_responses, initiated_date } = data;

  return (
    <div className="space-y-4 pb-10">
    <div className=" bg-white w-full mx-auto overflow-hidden border rounded-lg">
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-lg font-medium">Initial Questionnaire Responses</h2>
        <p className="text-sm text-gray-500">Initiated on: {initiated_date}</p>
      </div>

      <div>
        {Object.entries(questionnaire_responses).map(([question, answer], index) => (
          <div key={index} className="p-4">
            <p className="text-sm font-medium text-gray-700">{question}</p>
            <p className="mt-1">{answer}</p>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

interface QuestionnaireProps {
    questionnaireData: PatientQuestionnaire | null;
}

export const Questionnaire = ({ questionnaireData }: QuestionnaireProps) => {
    const defaultQuestionnaire: PatientQuestionnaire = {
        status: '',
        message: '',
        questionnaire_responses: {},
        supplementary_questionnaire: {
          question_answer: {}
        },
        initiated_date: ''
    };

    return <PatientQuestionnaireCard data={questionnaireData ?? defaultQuestionnaire} />;
}

